/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Flex } from '@chakra-ui/layout'
import { useEffect, useState } from 'react'
import { MdOutlineTrendingUp } from 'react-icons/md'
import { useNavigate } from 'react-router'
import { ButtonCmp } from '../../../components/ButtonCmp'
import LoadingContainer from '../../../components/LoadingContainer'
import { NavLine } from '../../../components/NavLine'
import { SelectCmp } from '../../../components/SelectCmp'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { useAuth } from '../../../contexts/AuthContext'
import { CargoOrganogramaResponse, iNomeId } from '../../../interfaces'
import { appApi } from '../../../services/appApi'
import { parseJwt } from '../../../services/token'
import { Body } from '../../Layouts/Body'
import { Sidebar } from '../Gestao/components/Sidebar'
import TrilhaCarreiraFlow from './components/ReactFlow/Flow'

interface iModel {
  cargos: CargoOrganogramaResponse[]
  departamentos: iNomeId[]
}

export const Trilhas: React.FC = () => {
  const nav = useNavigate()
  const { temAlgumaPermissao } = useAuth()
  const acessoCargos = parseJwt().adm === 'True' || temAlgumaPermissao('CargosESalarios')
  const [IsLoading, setIsLoading] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [DepartamentoAtual, setDepartamentoAtual] = useState('')
  const [Organograma, setOrganograma] = useState<iModel>()

  function GetOrganograma(): void {
    setIsLoading(true)

    appApi.get(`api/CargosESalarios/Organograma?departamentoId=${DepartamentoAtual}`)
      .then((res) => {
        const data = res.data as iModel
        setOrganograma({ ...data, departamentos: DepartamentoAtual === '' ? data.departamentos : (Organograma?.departamentos ?? []) })
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    GetOrganograma()
  }, [])

  useEffect(() => {
    if (Organograma) {
      GetOrganograma()
    }
  }, [DepartamentoAtual])

  return (
    <Flex justifyContent={'center'} alignItems={'self-start'} pos={'relative'} gap={'2rem'} margin={'0 auto'} pr={'2rem'}>
      <Flex
        position="sticky"
        top="0"
        left="0"
        direction="column"
        bg="white"
        transition="width 0.3s"
        width={isCollapsed ? '60px' : '220px'}
        height="100vh">
        <Sidebar isCollapsed={isCollapsed} onCollapse={setIsCollapsed} selecionado={'Trilhas de carreira'}/>
      </Flex>
      <Body isLoading={IsLoading} style={{ width: '100%' }} width={'100%'}>
        <Flex flexDir={'column'} gap={'1rem'}>
          <Flex justifyContent={'space-between'}>
            <NavLine
              options={[
                {
                  nome: acessoCargos ? 'Cargos' : '',
                  path: '/Descritivo/Cargos'
                },
                {
                  nome: 'Trilhas de carreira'
                }
              ]}
            />
            <ButtonCmp VarColor='c6' onClick={() => nav(-1)}>Voltar</ButtonCmp>
          </Flex>
          <Flex justifyContent={'space-between'}>
            <h1>Trilhas de carreira</h1>
          </Flex>
        </Flex>
        <Flex flexDir={'column'} gap={'1rem'} my={'1rem'}>
          <LoadingContainer loading={IsLoading} linhas={24}>
            <WhiteContainer padding='1.5rem'>
              <Flex justifyContent={'space-between'} alignItems={'center'} mb={'1rem'}>
                <Flex alignItems={'center'} color={'var(--Azul)'} gap={'.5rem'}>
                  <MdOutlineTrendingUp size={22}/>
                  <h3>Trilha de carreira geral</h3>
                </Flex>
                <SelectCmp width={'18rem'} title='Filtrar por área' value={DepartamentoAtual} OnChange={setDepartamentoAtual}>
                  <option value={''}>Visão geral</option>
                  {Organograma?.departamentos.map(e => {
                    return <option value={e.id}>{e.nome}</option>
                  })}
                </SelectCmp>
              </Flex>
              {Organograma && <TrilhaCarreiraFlow cargos={Organograma.cargos} departamentoId={DepartamentoAtual} departamentos={Organograma.departamentos} aoSalvarLigacoes={GetOrganograma}/>}
            </WhiteContainer>
          </LoadingContainer>
        </Flex>
      </Body>
    </Flex>
  )
}
